import { memo } from "react";
import { useTranslation } from "react-i18next";
import ModalFooterMessage, { EModalMessageKind } from "./ModalFooterMessage";
import useMobile from "src/hooks/useMobile";

const ModalHasUnsavedChanges: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  return (
    <ModalFooterMessage
      kind={EModalMessageKind.WARNING}
      message={
        isMobile ? t("misc:strings.unsaved") : t("misc:strings.unsaved_changes")
      }
      hideTextInMobile={false}
    />
  );
};

export default memo(ModalHasUnsavedChanges);
